import { Box, Tab, Tabs } from "@mui/material";
import React from "react";
import useQueryParams from "src/hooks/useQueryParams";

export default function TabComp({ tabs }) {
  const [option, setOption] = useQueryParams();

  const handleGetValue = (_, value) => {
    const item = tabs.find((v) => v.id === value);
    if (option?.child) {
      setOption({
        ...option,
        child: value,
        childTab: undefined,
        source: undefined,
      });
    } else {
      setOption({
        ...option,
        tab: value,
        childTab: item?.childTab,
        source: undefined,
      });
    }
  };

  return (
    <Box sx={{ borderBottom: "1px solid var(--grey)" }}>
      <Tabs
        value={option.tab}
        onChange={handleGetValue}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ minHeight: "36px !important" }}
      >
        {tabs.map((v) => {
          return (
            ((!!v?.display && v?.display) || v?.display === undefined) && (
              <Tab
                value={v.id}
                disabled={!!v?.disabled}
                sx={{
                  p: "4px 16px !important",
                  minHeight: "36px !important",
                  borderBottom: option.tab === (v.id ?? "true") ? "2px solid var(--black) !important" : "",
                }}
                key={v.id}
                label={v.name}
              />
            )
          );
        })}
      </Tabs>
    </Box>
  );
}
